import React from "react";

function DamagedBanner(props) {
  const { message, bgColor = null, marginTop = null, padding = null, damaged = true} = props;

  return (
    <div
      style={{ 
        display: 'flex',
        padding: padding || '10px',
        alignItems: 'center',
        backgroundColor: bgColor || '#FEF6E7',
        border: bgColor ? 'none' : '1px solid #FEAB10',
        borderRadius: '4px',
        marginBottom: '10px',
        marginTop: marginTop || '10px',
        fontSize: '12px',
      }}>
      <div className={`fa ${damaged ? 'icon-damaged' : 'icon-exceed-limit'} fa-fw`} style={{ alignSelf: 'center', marginRight: '8px', backgroundSize: 'contain' }}/>
      <div>{message}</div>
    </div>
  )
}
export default DamagedBanner;


/** WEBPACK FOOTER **
 ** ./src/components/DamagedBanner.js
 **/